<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div>
    <PopupV2
      :show.sync="showPopupV2"
      title="Generate New Financial Year"
      @buttonClicked="onClick"
      height="400px" 
      width="400px"
      :buttons="popUpButtons"
    >
      <div>
        <p>The latest financial year is {{currFYear}}</p>
        <p>Please select which financial year to generate</p>
        <Dropdown 
          :items="listOfYears"
          itemKey="year"
          placeholder="Select Year"
          :selectedObject.sync="selectedYear"
          :isRequired="true"
          :errorMessage="errorMsg"
        />
      </div>

    </PopupV2>
  </div>
  
</template>

<script>
export default {
  computed: {

  },
  data: function() {
    return {
      currFYear: 0,
      showPopupV2: false,
      popUpButtons: [{ text: 'Generate' },{ text: 'Cancel' }],
      listOfYears: [],
      selectedYear: {},
      errorMsg: ""
    };
  },
  props: {
  },
  methods: {
    async getLatestFYear() {
      this.$fullscreenLoading('Getting Latest Financial Year');
      const postBody = {
        masterfile: 'LATESTFYEAR'
      };
      
      const data = await this.$apiCallV2('/FINGLJournal/GetFINGLList', postBody);
      this.currFYear = parseInt(data[0].fYear);
      this.$fullscreenLoading('');
    },
    async genNextFYear() {
      if(this.selectedYear){
          this.errorMsg = "";
          this.$fullscreenLoading('Generating New Financial Year');
          const postBody = {
            fyear: Number(this.selectedYear.year) - 1
          };
          const data = await this.$apiCallV2('/FINGLGenNewFYear/GenerateNewFYear', postBody);
          this.$fullscreenLoading('');

          if(data[0]["Results"] === "1"){
            await this.$showAlert(
                  'error',
                  `Generate New Financial Year Failed`,
                  `${data[0]["ErrMsg"]}`,
            );            
          }
          else{
            const successAlert = await this.$showAlert(
                  'success',
                  `Generate New Financial Year Successful`,
                  `${data[0]["ErrMsg"]}`,
            );

            if(successAlert === "OK"){
              const userParam = this.$route.params['user'];
              this.$router.push(`/Home/${userParam}`);
            }
          }

      }
      this.errorMsg = `Year is required!`;

    },
    async generateValidFYears(){
      this.listOfYears = [];

      // getStartFYear
      this.$fullscreenLoading('Getting Starting Financial Year');
      const data = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=FINGL_MinYrGenNewYr');
      this.$fullscreenLoading('');
      const startFYear = data[0].SettingsValue;

      // Loop through the range (inclusive) and add object to the array
      for (let year = this.currFYear+1; year >= startFYear; year--) {
        this.listOfYears.push({ year: String(year) }); 
      }
    },
    async onClick(e){
      switch(e){
        case "Generate":{
          await this.genNextFYear();
          break;
        }
        case "Cancel":{
          this.showPopupV2 = false;
          const userParam = this.$route.params['user'];
          this.$router.push(`/Home/${userParam}`);
          break;
        }
      }
      
    }
  },
  async mounted() {
    await this.getLatestFYear();
    this.showPopupV2 = true;
    await this.generateValidFYears();
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

</style>